import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import type { Locale } from 'date-fns'

type LocaleLoader = () => Promise<Locale>
const localeMap: Record<string, LocaleLoader> = {
  en: async () => (await import('date-fns/locale/en-GB')).enGB,
  'en-US': async () => (await import('date-fns/locale/en-US')).enUS,
  fr: async () => (await import('date-fns/locale/fr')).fr,
  'fr-FR': async () => (await import('date-fns/locale/fr')).fr
}

export function useDateFnsLocale() {
  const { i18n } = useTranslation()

  const [locale, setLocale] = useState<Locale>()
  useEffect(() => {
    async function loadLocale(language: string) {
      try {
        setLocale(await localeMap[language]())
      } catch (error) {
        console.error('Failed to load locale:', error)
        setLocale(await localeMap['en']())
      }
    }

    loadLocale(i18n.language)
  }, [i18n.language])

  return locale
}
